import React, { useCallback, useEffect, useRef } from "react";
import "../../../public/pdfjs-5.1.91-dist/web/viewer.mjs";
import "../../../public/pdfjs-5.1.91-dist/build/pdf.mjs";
import "../../../public/pdfjs-5.1.91-dist/build/pdf.worker.mjs";
import "../../../public/pdfjs-5.1.91-dist/web/locale/locale.json";
import "../../../public/pdfjs-5.1.91-dist/web/locale/ja/viewer.ftl";
import helper from "./helper";

interface Props {
  src: string;
  visibleSaveButton?: boolean; // 保存ボタンの表示フラグ
  visiblePrintButton?: boolean; // 印刷ボタンの表示フラグ
  minHeight?: number;
  highlightText?: string;
}

const PdfViewer: React.FunctionComponent<Props> = ({
  src,
  visibleSaveButton = true,
  visiblePrintButton = true,
  minHeight = 0,
  highlightText
}) => {
  const viewerRef = useRef<HTMLDivElement>(null);

  const resize = useCallback(() => {
    const width = viewerRef.current?.getElementsByTagName("iframe")[0]
      .clientWidth;

    if (!width || !viewerRef.current) return;
    const height = Math.max((width * 3) / 4 + 15, minHeight);
    viewerRef.current.getElementsByTagName(
      "iframe"
    )[0].style.height = `${height}px`;
  }, [minHeight]);

  useEffect(() => {
    const element = viewerRef.current;

    if (!element) return;

    element.innerHTML = "";

    new helper().init(src, element, {
      visibleSaveButton,
      visiblePrintButton,
      highlightText
    });

    resize();

    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
      element.innerHTML = "";
    };
  }, [highlightText, resize, src, visiblePrintButton, visibleSaveButton]);

  return <div ref={viewerRef} id="viewer" />;
};

export default PdfViewer;
